export default __webpack_public_path__ + "static/media/booket-app-icon.5a104e15.svg";